import { Component, OnInit } from '@angular/core';
import {DescriptiveDataBackEnd, RatingEditorService} from "../../../services/rating-editor.service";

@Component({
  selector: 'app-rating-editor-buttons-section',
  templateUrl: './rating-editor-buttons-section.component.html',
  styleUrls: ['./rating-editor-buttons-section.component.scss']
})
export class RatingEditorButtonsSectionComponent implements OnInit {

  private _createSaveNames = {
    create: 'Создать',
    save: 'Сохранить',
  }
  public declineButtonName = 'Отмена';
  public notificationIsVisible = false;
  private _createSaveButtonStatesToCSS = {
    active: 'btn btn-log btn-sm',
    disabled: 'blockedCreateButtonStyle',
  };

  private _notificationTexts = {
    create: 'Рейтинг успешно создан',
    save: 'Рейтинг успешно изменён',
  }
  constructor(
    private pageService: RatingEditorService
  ) { }

  ngOnInit(): void {
  }

  createSaveButtonName() {
    return this.pageService.brandNewRating
      ? this._createSaveNames.create
      : this._createSaveNames.save;
  }

  createSaveDisabled(): boolean {
    return !this.pageService.saveOrCreateIsEnabled();
  }

  createSaveButtonStyle() {
    return this.createSaveDisabled()
      ? this._createSaveButtonStatesToCSS.disabled
      : this._createSaveButtonStatesToCSS.active;
  }

  afterSaveProcedure() {
    this.notificationIsVisible = true;
    setTimeout(() => {
      this.notificationIsVisible = false;
      window.history.back();
    }, 1000);
  }

  saveCreateButtonClickHandler() {
    if (!this.createSaveDisabled()) {
      if (this.pageService.brandNewRating) {
        this.pageService.createNewRating()
          .subscribe((response: DescriptiveDataBackEnd) => {
            this.pageService.ratingIdToModify = response.rating_id;
            this.pageService.saveRatingPoints().subscribe(() => this.afterSaveProcedure());
          })
      } else {
        this.pageService.updateRating()
          .subscribe(() => {
            this.pageService.saveRatingPoints().subscribe(() => this.afterSaveProcedure());
          })
      }
    }
  }

  cancelClickHandler() {
    window.history.back();
  }

  notificationText() {
    return this.pageService.brandNewRating
      ? this._notificationTexts.create
      : this._notificationTexts.save;
  }

}
